import { createAction, props } from '@ngrx/store';

export const setIsMobile = createAction(
  '[Device] Set Is Mobile',
  props<{ isMobile: boolean }>(),
);
